import AppConstants from '../constants/AppConstants';

export const initialState = {
    item: {},
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.AGGREGATION_INFO_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.AGGREGATION_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                item: action.item
            };

        case AppConstants.AGGREGATION_INFO_FAIL:
            return {
                ...state,
                loading: false
            };

        case AppConstants.AGGREGATION_INFO_CLOSE:
            return {
                ...state,
                loading: true
            };

        case AppConstants.AGGREGATION_INFO_CLOSE_SUCCESS:
            return {
                ...state,
                item: {},
                loading: false
            };

        default:
            return state;
    }
};
